"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPWearable = void 0;
const validation_1 = require("../../validation");
const merkle_tree_1 = require("../merkle-tree");
const base_wearable_1 = require("./base-wearable");
/** @alpha */
var TPWearable;
(function (TPWearable) {
    TPWearable.schema = {
        ...base_wearable_1.BaseWearable.schema,
        properties: {
            ...base_wearable_1.BaseWearable.schema.properties,
            content: {
                type: 'object',
                additionalProperties: { type: 'string' },
                required: []
            },
            merkleProof: merkle_tree_1.MerkleProof.schema
        },
        required: [...base_wearable_1.BaseWearable.schema.required, 'content']
    };
    const schemaValidator = (0, validation_1.generateValidator)(TPWearable.schema);
    TPWearable.validate = (wearable) => schemaValidator(wearable) &&
        base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.descriptions) &&
        base_wearable_1.BaseWearable.validateDuplicatedLocales(wearable.names);
})(TPWearable = exports.TPWearable || (exports.TPWearable = {}));
//# sourceMappingURL=tp-wearable.js.map